<div class="flex h-full flex-col gap-4" *transloco="let t">
  <div class="flex items-center justify-between">
    <div class="font-medium text-gray-600">{{ t("sd-strategy-creation.advertised_products") }}</div>

    <div class="flex gap-2">
      <IButton
        [ngClass]="{ 'opacity-100': selectedAsins().length > 0 }"
        class="opacity-0"
        [label]="deleteButtonLabel()"
        icon="icon-[lucide--trash]"
        color="red"
        [disabled]="isAllAsinsSelected()"
        [loading]="deleteAsinLoading()"
        (onClick)="deleteProductsFromStrategy(selectedAsins())"
        [trailing]="true"
        [tooltipValue]="isAllAsinsSelected() ? t('strategy-page.cannot_delete_all_products') : undefined"
      />
      <IButton
        [label]="t('sp-substrategy.add_products')"
        icon="icon-[lucide--plus]"
        color="white"
        (onClick)="openAddAsinsModal()"
      />
    </div>
  </div>
  <app-asin-selection
    class="min-h-0 flex-1"
    ineligibilityTag="SP"
    [customList]="strategyGroupAsins()"
    [readonly]="isReadOnly()"
    [csvExport]="true"
    [withBulk]="false"
    [withGroupByParent]="false"
    [(selectedAsins)]="selectedAsins"
  />

  <ng-template #addAsinsModal>
    @if (addAsinsModalState() === AddAsinsModalState.PRODUCTS) {
      <div class="flex h-[60vh] w-[60rem] flex-col gap-4">
        <app-asin-selection
          class="min-h-0 flex-1"
          [customList]="availableAsins()"
          [readonly]="isReadOnly()"
          [(selectedAsins)]="addAsinsSelected"
        />

        <div class="flex justify-end gap-2">
          <IButton [label]="t('common.cancel')" color="white" size="sm" (onClick)="closeAddProductsModal()" />
          <IButton
            [label]="t('common.continue')"
            size="sm"
            [disabled]="addAsinsSelected().length === 0"
            (onClick)="addAsinsModalState.set(AddAsinsModalState.STRATEGY)"
          />
        </div>
      </div>
    }
    @if (addAsinsModalState() === AddAsinsModalState.STRATEGY) {
      <div
        class="flex flex-col gap-4 duration-150"
        [ngClass]="[addAsinsModalState() === AddAsinsModalState.STRATEGY ? 'w-[40rem]' : 'w-[60rem]']"
      >
        <div class="flex flex-1 flex-col gap-4 divide-y divide-gray-200">
          <div class="flex flex-col gap-2">
            <span class="text-sm font-medium text-gray-600">{{
              t("sp-strategy-group-page.select_main_strategy")
            }}</span>
            <ISelect
              [options]="strategyGroupProductStrategies()"
              [selectedValue]="selectedMainStrategy()"
              (selectedOptionChange)="selectedMainStrategy.set($event.value)"
            />
          </div>

          @if (strategyGroup()?.brandStrategies?.length) {
            <div class="space-y-2 pt-4">
              <span class="text-sm font-medium text-gray-600">{{
                t("sp-strategy-group-page.select_brand_defense_strategy")
              }}</span>
              <div class="flex flex-col gap-2">
                @for (s of strategyGroup()?.brandStrategies; track s.strategyId) {
                  <div class="flex items-center gap-2">
                    <ICheckbox
                      [label]="s.strategyName"
                      [value]="strategyGroupBrandSelection.has(s.strategyId)"
                      (valueChange)="toggleStrategyToSelection(s, $event)"
                    />
                  </div>
                }
              </div>
            </div>
          }

          @if (strategyGroup()?.keywordStrategies?.length) {
            <div class="space-y-2 pt-4">
              <span class="text-sm font-medium text-gray-600">{{
                t("sp-strategy-group-page.select_focus_strategy")
              }}</span>
              <div class="flex flex-col gap-2">
                @for (s of strategyGroup()?.keywordStrategies; track s.strategyId) {
                  <div class="flex items-center gap-2">
                    <ICheckbox
                      [label]="s.strategyName"
                      [value]="strategyGroupFocusSelection.has(s.strategyId)"
                      (valueChange)="toggleStrategyToSelection(s, $event)"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="flex justify-end gap-2">
          <IButton
            size="sm"
            [label]="t('common.previous')"
            color="white"
            (onClick)="addAsinsModalState.set(AddAsinsModalState.PRODUCTS)"
          />
          <IButton
            [label]="t('sp-substrategy.add_n_products', { count: addAsinsSelected().length })"
            size="sm"
            [disabled]="addAsinsSelected().length === 0"
            (onClick)="addProducts()"
            [loading]="addAsinsLoading()"
          />
        </div>
      </div>
    }
  </ng-template>
</div>
